import { ptBR } from "date-fns/locale";
import { forwardRef, useEffect, useState } from "react";
import DatePicker, {
  CalendarContainer,
  registerLocale,
} from "react-datepicker";
import { CalendarIcon } from "../../assets/icons/CalendarIcon";
import {
  DatePickerContainer,
  Label,
  Text,
  Content,
  CustomButton,
  Container,
} from "./styles";
import ReactLoading from "react-loading";

registerLocale("pt-BR", ptBR);

const DateCustomInput = forwardRef(({ children, onClick }, ref) => (
  <div onClick={onClick} ref={ref}>
    {children}
  </div>
));
const CustomContainer = ({
  date,
  diffHours,
  children,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  return (
    <Container>
      <DatePickerContainer>
        <Label style={{ marginBottom: "0.7rem" }}>
          Selecione a nova data para a Tarefa:
        </Label>
        <Text style={{ marginBottom: "0.5rem", color: "#d9534f" }}>
          ATENÇÃO: Esta Tarefa não poderá retroceder além da nova data!
        </Text>
        <Text style={{ marginBottom: "0.8rem" }}>
          {date} (+{(diffHours + 24).toFixed(1)} Hrs )
        </Text>
        <Content>
          <CalendarContainer>
            <div
              style={{
                position: "relative",
              }}
            >
              {children}
            </div>
          </CalendarContainer>
        </Content>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "2rem",
          }}
        >
          {isLoading ? (
            <ReactLoading height={50} width={50} type="spin" color="#118052" />
          ) : (
            <>
              <CustomButton
                onClick={onConfirm}
                disabled={diffHours < 0}
                style={{
                  color: "#40e5a0",
                  marginRight: "3rem",
                  opacity: diffHours < 0 ? "0.3" : "1",
                }}
              >
                <CalendarIcon />
                Confirmar
              </CustomButton>
              <CustomButton
                onClick={onCancel}
                style={{
                  color: "#d9534f",
                }}
              >
                Cancelar
              </CustomButton>
            </>
          )}
        </div>
      </DatePickerContainer>
    </Container>
  );
};
export const DatePickerWrapper = ({
  refPicker,
  state,
  date,
  children,
  onConfirm,
  isLoading,
}) => {
  const dateFormat = "dd/MM/yyyy HH:mm";
  const locale = "pt-BR";

  const [delay, setDelay] = state;
  const [minDate] = useState(delay);
  const [minTime, setMinTime] = useState(new Date());
  const maxTime = new Date(0, 0, 0, 23, 59);

  // Função para formatar a data no formato desejado
  const formatDate = (date) => {
    return date.setLocale(locale).toFormat(dateFormat);
  };

  let handleColor = (time) => {
    return time.getHours() > 12 ? "text-success" : "text-error";
  };

  let opcoes = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  const dateString = delay.toLocaleString("pt-BR", opcoes);

  const diffHours = (delay - minDate) / (1000 * 60 * 60);

  const setOpen = refPicker.current?.setOpen;

  useEffect(() => {
    if (delay.toDateString() === minDate.toDateString()) {
      setMinTime(new Date(0, 0, 0, minDate.getHours(), minDate.getMinutes())); // Define o horário mínimo para a hora de minDate se a data selecionada for a data mínima
    } else {
      setMinTime(new Date(0, 0, 0, 0, 0)); // Caso contrário, permite qualquer horário
    }
  }, [delay, minDate]);

  return (
    <DatePicker
      ref={refPicker}
      withPortal
      showTimeSelect
      portalId="root"
      shouldCloseOnSelect={false}
      timeClassName={handleColor}
      selected={delay}
      onChange={(date) => {
        setDelay(date);
      }}
      locale={locale}
      timeFormat="HH:mm"
      timeIntervals={15}
      dateFormat={dateFormat}
      minDate={minDate}
      minTime={minTime}
      maxTime={maxTime}
      calendarContainer={(props) => (
        <CustomContainer
          isLoading={isLoading}
          onConfirm={async () => {
            onConfirm(delay)
              .then(() => setOpen(false))
              .catch((error) => {
                console.log(error);
                setOpen(false);
              });
          }}
          onCancel={() => setOpen(false)}
          diffHours={diffHours}
          date={dateString}
          {...props}
        />
      )}
      customInput={
        <DateCustomInput value={formatDate(date)} children={children} />
      }
    />
  );
};
